var _global = typeof window === 'object' && window.window === window ?
    window : typeof self === 'object' && self.self === self ?
        self : typeof global === 'object' && global.global === global ?
            global :
            this;

function bom(blob, opts) {
    if (typeof opts === 'undefined') opts = {
        autoBom: false
    };
    else if (typeof opts !== 'object') {
        opts = {
            autoBom: !opts
        }
    }
    if (opts.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
        return new Blob([String.fromCharCode(0xFEFF), blob], {
            type: blob.type
        })
    }
    return blob
}

function download(url, name, opts) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function() {
        saveAs(xhr.response, name, opts)
    };
    xhr.send()
}

function corsEnabled(url) {
    let xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false);
    xhr.send();
    return xhr.status >= 200 && xhr.status <= 299
}

// `a.click()` doesn't work for all browsers (#465)
function click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'))
    } catch (e) {
        var evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80,
            20, false, false, false, false, 0, null);
        node.dispatchEvent(evt)
    }
}

var saveAs = _global.saveAs || (
    // probably in some web worker
    (typeof window !== 'object' || window !== _global) ?
        function saveAs() { /* noop */ }

        // Use download attribute first if possible (#193 Lumia mobile)
        :
        'download' in HTMLAnchorElement.prototype ?
            function saveAs(blob, name, opts) {
                var URL = _global.URL || _global.webkitURL;
                var a = document.createElement('a');
                name = name || blob.name || 'download';

                a.download = name;
                a.rel = 'noopener'; // tabnabbing

                if (typeof blob === 'string') {
                    // Support regular links
                    a.href = blob;
                    if (a.origin !== location.origin) {
                        corsEnabled(a.href) ?
                            download(blob, name, opts) :
                            click(a, a.target = '_blank')
                    } else {
                        click(a)
                    }
                } else {
                    a.href = URL.createObjectURL(blob);
                    setTimeout(function() {
                        URL.revokeObjectURL(a.href)
                    }, 4E4); // 40s
                    setTimeout(function() {
                        click(a)
                    }, 0)
                }
            }
            :
            'msSaveOrOpenBlob' in navigator ?
                function saveAs(blob, name, opts) {
                    name = name || blob.name || 'download';

                    if (typeof blob === 'string') {
                        if (corsEnabled(blob)) {
                            download(blob, name, opts)
                        } else {
                            var a = document.createElement('a');
                            a.href = blob;
                            a.target = '_blank';
                            setTimeout(function() {
                                click(a)
                            })
                        }
                    } else {
                        navigator.msSaveOrOpenBlob(bom(blob, opts), name)
                    }
                }

                :
                function saveAs(blob, name, opts, popup) {
                    // Open a popup immediately do go around popup blocker
                    // Mostly only available on user interaction and the fileReader is async so...
                    popup = popup || open('', '_blank');
                    if (popup) {
                        popup.document.title =
                            popup.document.body.innerText = 'downloading...'
                    }

                    if (typeof blob === 'string') return download(blob, name, opts);

                    var force = blob.type === 'application/octet-stream';
                    var isSafari = /constructor/i.test(_global.HTMLElement) || _global.safari;
                    var isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);

                    if ((isChromeIOS || (force && isSafari)) && typeof FileReader === 'object') {
                        var reader = new FileReader();
                        reader.onloadend = function() {
                            var url = reader.result;
                            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
                            if (popup) popup.location.href = url;
                            else location = url;
                            popup = null // reverse-tabnabbing #460
                        };
                        reader.readAsDataURL(blob)
                    } else {
                        var URL = _global.URL || _global.webkitURL;
                        var url = URL.createObjectURL(blob);
                        if (popup) popup.location = url;
                        else location.href = url;
                        popup = null; // reverse-tabnabbing #460
                        setTimeout(function() {
                            URL.revokeObjectURL(url)
                        }, 4E4) // 40s
                    }
                }
);
export default {
    Constantes: {
        pasos: [
            {
                numero:1,
                titulo:"Búsqueda",
                icono:"fas fa-map-marker-alt"
            },
            {
                numero:2,
                titulo:"Información",
                icono:"fas fa-chart-line",
            },
            // {
            //     numero:3,
            //     titulo:"Avance",
            //     icono:"fas fa-clipboard-check"
            // },
        ],
        mapaEstilos:[
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#ca2031"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 65
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 51
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 30
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 40
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffff00"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -97
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "58"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -100
                    }
                ]
            }
        ]
    },
    funciones:{
        minusculas:function(texto){
            let aux=String(texto);
            return aux.toLocaleLowerCase();
        },
        descargar:function(blob,nombre){
            return saveAs(blob,nombre);
        },
        soloNumeros:function (evt) {
            evt = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        validarCi:function(value,opcion){
            let valor;
            let porcion1=0;
            let acu=0;
            let number = value;
            let dto = number.length;
            if(opcion){
                switch (opcion.id) {
                    case 1:
                        for (let i=0; i<dto; i++){
                            valor = parseInt(number.substring(i,i+1));
                            if(valor===0||valor===1||valor===2||valor===3||valor===4||valor===5||valor===6||valor===7||valor===8||valor===9){
                                acu = acu+1;
                            }
                        }
                        if(acu===dto){
                            while(number.substring(10,13)!=="001")
                                return false;
                            while(number.substring(0,2)>24)
                                return false;
                            porcion1 = number.substring(2,3);
                            if(porcion1<6)
                                return true;//persona natural
                            else
                            if(porcion1===6)
                                return true;//entidad publica
                            else
                            if(porcion1===9)
                                return true;//sociedad privada
                            return false;
                        }else{
                            return false
                        }

                    case 2:
                        for (let i=0; i<dto; i++){
                            valor = parseInt(number.substring(i,i+1));
                            if(valor===0||valor===1||valor===2||valor===3||valor===4||valor===5||valor===6||valor===7||valor===8||valor===9){
                                acu = acu+1;
                            }
                        }
                        if(acu===dto){
                            while(number.substring(10,13)!=="001")
                                return false;
                            while(number.substring(0,2)>24)
                                return false;
                            porcion1 = number.substring(2,3);
                            if(porcion1<6)
                                return true;//persona natural
                            else
                            if(porcion1===6)
                                return true;//entidad publica
                            else
                            if(porcion1===9)
                                return true;//sociedad privada
                            return false;
                        }else{
                            return false
                        }
                    case 3:
                        if (typeof(value) == 'string' && value.length === 10 && /^\d+$/.test(value)) {
                            let digitos = value.split('').map(Number);
                            let codigo_provincia = digitos[0] * 10 + digitos[1];
                            if (codigo_provincia >= 1 && (codigo_provincia <= 24 || codigo_provincia === 30)) {
                                let digito_verificador = digitos.pop();
                                let digito_calculado = digitos.reduce(
                                    function (valorPrevio, valorActual, indice) {
                                        return valorPrevio - (valorActual * (2 - indice % 2)) % 9 - (valorActual === 9) * 9;
                                    }, 1000) % 10;
                                return digito_calculado === digito_verificador;
                            }
                        }
                        return false;
                    case 4:
                        return value.length >= opcion.ndt1;
                    default:
                        return true;
                }
            }else{
                return false;
            }
        },
    }
};
